import { render } from "./travelLogisticMobilityActivityRecorderDetail.vue?vue&type=template&id=4d21592c&ts=true"
import script from "./travelLogisticMobilityActivityRecorderDetail.vue?vue&type=script&lang=ts"
export * from "./travelLogisticMobilityActivityRecorderDetail.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__